/* =========================================================
   The Design — hotspot interactions + stat count-up
   ========================================================= */

(function () {
  'use strict';

  function initDesign(root) {
    if (!root || root.dataset.designInit === 'true') return;
    root.dataset.designInit = 'true';

    const reducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ---------- Reveal on scroll ----------
    const revealEls = root.querySelectorAll('.reveal');

    if ('IntersectionObserver' in window && revealEls.length) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('in');
              io.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.12,
          rootMargin: '0px 0px -50px 0px',
        }
      );
      revealEls.forEach((el) => io.observe(el));
    } else {
      revealEls.forEach((el) => el.classList.add('in'));
    }

    // ---------- Hotspot click toggle (mobile-friendly) ----------
    const annotations = root.querySelectorAll('.design__anno');
    annotations.forEach((anno) => {
      const hotspot = anno.querySelector('.design__hotspot');
      if (!hotspot) return;

      hotspot.addEventListener('click', (e) => {
        e.stopPropagation();
        const wasActive = anno.classList.contains('is-active');

        // Close all others
        annotations.forEach((a) => a.classList.remove('is-active'));

        // Toggle this one
        if (!wasActive) anno.classList.add('is-active');
      });
    });

    // Close active annotation when clicking outside
    document.addEventListener('click', (e) => {
      if (!root.contains(e.target)) {
        annotations.forEach((a) => a.classList.remove('is-active'));
      }
    });

    if (reducedMotion) return;

    // ---------- Stats count-up ----------
    const stats = root.querySelectorAll('.design__stat strong');
    stats.forEach((statEl) => {
      const valAttr = statEl.dataset.statValue || statEl.textContent.trim();
      // Extract the numeric portion and any leading/trailing text
      const match = valAttr.match(/^(\D*)([\d,\.]+)(\D*)$/);
      if (!match) return;

      const prefix = match[1];
      const numStr = match[2].replace(/,/g, '');
      const target = parseFloat(numStr);
      const suffixText = match[3];
      if (isNaN(target)) return;

      // Preserve the original markup (including <sup>) for restoration
      const finalHTML = statEl.innerHTML;
      statEl.dataset.finalHtml = finalHTML;

      // Find the <sup> element (if any) so we keep it visible during animation
      const supEl = statEl.querySelector('sup');
      const supHTML = supEl ? supEl.outerHTML : '';

      // Reset display to 0 (preserving sup)
      statEl.innerHTML = `${prefix}0${suffixText}${supHTML}`;

      const countIO = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              animateNumber(statEl, target, prefix, suffixText, supHTML, 1500);
              countIO.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.5 }
      );
      countIO.observe(statEl);
    });
  }

  function animateNumber(el, target, prefix, suffix, supHTML, duration) {
    const start = performance.now();
    const hasDecimal = target % 1 !== 0;

    function format(value) {
      const rounded = hasDecimal ? value.toFixed(2) : Math.round(value);
      // Add comma separators for thousands
      const formatted = rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return `${prefix}${formatted}${suffix}${supHTML}`;
    }

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function tick(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeOutCubic(progress);
      el.innerHTML = format(target * eased);

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        // Restore exact original markup at the end
        el.innerHTML = el.dataset.finalHtml;
      }
    }

    requestAnimationFrame(tick);
  }

  function initAll() {
    document.querySelectorAll('.design[data-section-id]').forEach(initDesign);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('.design[data-section-id]');
    if (root) initDesign(root);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const root = e.target.querySelector('.design[data-section-id]');
    if (root) root.dataset.designInit = '';
  });
})();





